import { datadogRum } from "@datadog/browser-rum";
import { ReleaseExperience, ReleaseHeadlineRelease } from "./releases";

// Named steps of a release announcement, so its funnel reads straight from
// Datadog instead of being inferred from button labels.
export type ReleaseStep =
  | "shown"
  | "opened"
  | "feature_expanded"
  | "feature_cta"
  | "full_release"
  | "opt_in"
  | "opt_in_confirmed"
  | "opt_in_done"
  | "opt_in_failed"
  | "closed";

// Previews (QA, Replay) send nothing, so they don't inflate the funnel.
export const trackRelease = (
  release: ReleaseHeadlineRelease,
  experience: ReleaseExperience,
  step: ReleaseStep,
  context: Record<string, string> = {},
  isPreview = false,
): void => {
  if (isPreview) return;
  datadogRum.addAction("release_announcement", {
    release: release.slug,
    experience,
    step,
    ...context,
  });
};
